import { defineMessages } from 'react-intl';

const messages = defineMessages({
    coownerLevelText: {
        defaultMessage: 'Co-owner',
        description: 'Text for Co-owner permission level in permissions table',
        id: 'boxui.share.coownerLevelText',
    },
    deleteTableHeaderText: {
        defaultMessage: 'Delete',
        description: 'Text for permissions table Delete column',
        id: 'boxui.share.deleteTableHeaderText',
    },
    downloadTableHeaderText: {
        defaultMessage: 'Download',
        description: 'Text for permissions table Download column',
        id: 'boxui.share.downloadTableHeaderText',
    },
    editorLevelText: {
        defaultMessage: 'Editor',
        description: 'Text for Editor permission level in permissions table',
        id: 'boxui.share.editorLevelText',
    },
    editTableHeaderText: {
        defaultMessage: 'Edit',
        description: 'Text for permissions table Edit column',
        id: 'boxui.share.editTableHeaderText',
    },
    getLinkTableHeaderText: {
        defaultMessage: 'Get Link',
        description: 'Text for permissions table Get Link column',
        id: 'boxui.share.getLinkTableHeaderText',
    },
    groupLabel: {
        defaultMessage: 'Group',
        description: 'Label for a Group contact type',
        id: 'boxui.share.groupLabel',
    },
    inviteCollaboratorsModalCancelButton: {
        defaultMessage: 'Cancel',
        description: 'Text on button to cancel and close the invite collaborators modal.',
        id: 'boxui.share.inviteCollaboratorsModalCancelButton',
    },
    inviteCollaboratorsModalSendInvitesButton: {
        defaultMessage: 'Send Invites',
        description: 'Text on button to send invitations to collaborators for an item',
        id: 'boxui.share.inviteCollaboratorsModalSendInvites',
    },
    inviteCollaboratorsModalTitle: {
        defaultMessage: 'Invite to {itemName}',
        description:
            'Title of the Invite Collaborators Modal. {itemName} is the name of the file / folder being shared',
        id: 'boxui.share.inviteCollaboratorsModalTitle',
    },
    inviteePermissionsFieldLabel: {
        defaultMessage: 'Invitee Permissions',
        description: 'Label of the field where a user designates which permissions a collaborator will have on an item',
        id: 'boxui.share.inviteePermissionsFieldLabel',
    },
    inviteePermissionsLearnMore: {
        defaultMessage: 'Learn More',
        description: 'Tooltip text a user can use to learn more about collaborator permission options',
        id: 'boxui.share.inviteePermissionsLearnMore',
    },
    inviteFieldLabel: {
        defaultMessage: 'Invite',
        description: 'Label of the field where a user designates who to invite to collaborate on an item',
        id: 'boxui.share.inviteFieldLabel',
    },
    inviteFileEditorsLabel: {
        defaultMessage: 'Invite people to become editors of this file.',
        description: 'Label to invite editors to a file in the invite collab modal',
        id: 'boxui.share.inviteFileEditorsLabel',
    },
    permissionLevelsTableHeaderText: {
        defaultMessage: 'Permission Levels',
        description: 'Text for permissions table Permission Levels column',
        id: 'boxui.share.permissionLevelsTableHeaderText',
    },
    personalMessageLabel: {
        defaultMessage: 'Personal Message',
        description: 'Label for optional personal message to include when inviting collaborators to an item',
        id: 'boxui.share.personalMessageLabel',
    },
    previewTableHeaderText: {
        defaultMessage: 'Preview',
        description: 'Text for permissions table Preview column',
        id: 'boxui.share.previewTableHeaderText',
    },
    ownerTableHeaderText: {
        defaultMessage: 'Owner',
        description: 'Text for permissions table Owner column',
        id: 'boxui.share.ownerTableHeaderText',
    },
    previewerLevelText: {
        defaultMessage: 'Previewer',
        description: 'Text for Previewer permission level in permissions table',
        id: 'boxui.share.previewerLevelText',
    },
    previewerUploaderLevelText: {
        defaultMessage: 'Previewer Uploader',
        description: 'Text for Previewer Uploader permission level in permissions table',
        id: 'boxui.share.previewerUploaderLevelText',
    },
    referAFriendBadgeText: {
        defaultMessage: 'REFER',
        description: 'Text on a badge encouraging users to refer a friend to sign up for Box',
        id: 'boxui.share.referAFriendBadgeText',
    },
    referAFriendText: {
        defaultMessage: 'Want a free month of Box? Refer your friend!',
        description: 'Text encouraging users to refer a friend to sign up for Box',
        id: 'boxui.share.referAFriendText',
    },
    referAFriendRewardCenterLinkText: {
        defaultMessage: 'Click Here',
        description: 'Text on a link to the "Reward Center", where users can refer a friend to sign up for Box',
        id: 'boxui.share.referAFriendRewardCenterLinkText',
    },
    upgradeGetMoreAccessControls: {
        defaultMessage: 'Get More Access Controls',
        description: 'Label for link to upgrade to get more access controls for inviting collaborators to an item',
        id: 'boxui.share.upgradeGetMoreAccessControls',
    },
    uploaderLevelText: {
        defaultMessage: 'Uploader',
        description: 'Text for Uploader permission level in permissions table',
        id: 'boxui.share.uploaderLevelText',
    },
    uploadTableHeaderText: {
        defaultMessage: 'Upload',
        description: 'Text for permissions table Upload column',
        id: 'boxui.share.uploadTableHeaderText',
    },
    viewerLevelText: {
        defaultMessage: 'Viewer',
        description: 'Text for Viewer permission level in permissions table',
        id: 'boxui.share.viewerLevelText',
    },
    viewerUploaderLevelText: {
        defaultMessage: 'Viewer Uploader',
        description: 'Text for Viewer Uploader permission level in permissions table',
        id: 'boxui.share.viewerUploaderLevelText',
    },
});

export default messages;
